import md5 from 'md5';

export const validatePassword = (password) => {
  // Check if password is at least 8 characters long
  if (password.length < 8) {
    return 'password must be at least 8 characters long';
  }

  // Check if password contains at least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    return 'password must contain at least one uppercase letter';
  }

  // Check if password contains at least one lowercase letter
  if (!/[a-z]/.test(password)) {
    return 'password must contain at least one lowercase letter';
  }

  // Check if password contains at least one digit
  if (!/[0-9]/.test(password)) {
    return 'password must contain at least one digit';
  }

  // Check if password contains at least one special character
  if (!/[!@#$%^&*]/.test(password)) {
    return 'password must contain at least one special character';
  }

  return null;
};

export const authenticatePassword = (password) => {
  const storedHashedPasswords = ['c73faf16b04d54ad594fbc919cd4cd93'];
  const demoPassword = '5dd34c39d7d8c06b3513eb2b872810ec';
  const demoAnimationPassword = 'c398c51e4bbc9f73580d57ee96f820c9';
  const demoCybertruckPassword = '5dc6c7583ec72eb20ba9d1eab284251f';

  if (storedHashedPasswords.includes(md5(password))) {
    return 'authenticated';
  } else if (demoPassword === md5(password)) {
    return 'demo';
  } else if (demoAnimationPassword === md5(password)) {
    return 'demoAnimation';
  } else if (demoCybertruckPassword === md5(password)) {
    return 'demoCybertruck';
  }
  return 'invalid';
};
